import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Grid, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { Box } from '@mui/system'
import React from 'react'
import { useRecoilValue } from 'recoil'
import PasswordTemporalField from 'src/Patient/components/PasswordTemporalField'
import useSavePatient from 'src/Patient/hooks/useSavePatient'
import { valuesFormRegisterState } from 'src/Patient/state/atoms'
import ButtonCustom from 'src/shared/components/buttons/ButtonCustom'

const FormPasswordTemporal = () => {
    const { uswEmail } = useRecoilValue(valuesFormRegisterState);
    const { handleClickPasswordTemporal, loading } = useSavePatient()
    return (
        <div className='animate__animated animate__fadeIn'>
            <Typography variant="subtitle1" color="primary" textAlign={"center"}>
                ¡Clave temporal enviada!
            </Typography>

            <Typography variant="h5" color={grey[500]} mt={2} fontSize={16} textAlign={"center"}>
                Hemos enviado una clave temporal a su cuenta <strong style={{ color: grey[700] }}>{uswEmail}</strong>
            </Typography>
            <Grid container spacing={2} mt={2}>
                <Grid item md={12} xs={12}>
                    <PasswordTemporalField onKeyEnter={handleClickPasswordTemporal} />
                    <Typography variant="subtitle2" color={grey[400]} fontWeight={500} lineHeight={'15px'} fontSize={10} mt={1}>
                        ¿Aún no recibe el correo? Revise en Spam
                    </Typography>
                </Grid>
            </Grid>

            <Grid container display={"flex"} justifyContent={"center"} p={2} mt={1}>
                <Box>
                    <ButtonCustom
                        color="secondary"
                        loading={loading}
                        text="VERIFICAR CLAVE"
                        icon={<NavigateNextIcon />}
                        onClick={handleClickPasswordTemporal}
                    />
                </Box>

            </Grid>
        </div>
    )
}

export default FormPasswordTemporal
